import {Component} from 'react';
import maplibregl from '../maplibregl';

const markerMoves = new WeakMap()

class MapboxMap extends Component {
    createMap(style) {
        return new maplibregl.Map({
            container: 'map',
            style: `/map-style/${style}.json`,
            center: [5.55, 52],
            zoom: 10
        });
    }

    addMarker(map, element, className, lng, lat, popup, options = {}) {
        const el = document.createElement('div');
        el.className = className;
        if (element !== null) {
            el.innerHTML = element;
        }

        const marker = new maplibregl.Marker({
            element: el,
            anchor: options.anchor || 'bottom',
            offset: options.offset
        })

        if (popup !== null) {
            marker.setLngLat([lng, lat]).setPopup(popup).addTo(map);
        } else {
            marker.setLngLat([lng, lat]).addTo(map);
        }

        return marker
    }

    setMarkerLocation(marker, lng, lat) {
        const from = marker.getLngLat()
        const prev = markerMoves.get(marker)
        if (prev)
            cancelAnimationFrame(prev)

        if (!from || Math.abs(from.lng - lng) > 0.5 || Math.abs(from.lat - lat) > 0.5) {
            markerMoves.delete(marker)
            marker.setLngLat([lng, lat])
            return
        }

        const start = performance.now()
        const startLng = from.lng
        const startLat = from.lat

        const step = (now) => {
            const t = Math.min(1, (now - start) / 400)
            const ease = t * t * (3 - 2 * t)
            marker.setLngLat([
                startLng + (lng - startLng) * ease,
                startLat + (lat - startLat) * ease
            ])
            if (t < 1)
                markerMoves.set(marker, requestAnimationFrame(step))
            else
                markerMoves.delete(marker)
        }

        markerMoves.set(marker, requestAnimationFrame(step))
    }

    setMarkerHTML(marker, innerHTML) {
        marker.getElement().innerHTML = innerHTML;
    }

    setMarkerClass(marker, className) {
        marker.getElement().className = className;
    }

    createPopup(text) {
        return new maplibregl.Popup().setText(text);
    }

    flyTo(map, lat, lng, zoom) {
        if (!zoom) {
            map.easeTo({
                center: [lng, lat],
                duration: 400
            })
        } else {
            map.flyTo({
                center: [lng, lat],
                zoom: zoom
            });
        }
    }

}

export default MapboxMap;
